import { DateRangePicker } from '../input/DateRangePicker/DateRangePicker';
import { InlineAutocomplete } from '../input/InlineAutoComplete/InlineAutocomplete';
import { FilterWithOperator } from './FilterContent/FilterWithOperator';
import { DATA_TYPE_OPERATOR_MAP, FilterContentFieldDataTypes } from './constants';

export const FilterTypeRegistry: Record<FilterContentFieldDataTypes, unknown> = {
  [FilterContentFieldDataTypes.LIST]: {
    component: InlineAutocomplete,
    isOptionEqualToValue: (
      value: { label: string; [key: string]: unknown },
      option: { label: string; [key: string]: unknown }
    ) => value?.label === option?.label,
    disableClearable: true,
    renderTags: () => null
  },
  [FilterContentFieldDataTypes.NUMBER]: {
    component: FilterWithOperator,
    options: DATA_TYPE_OPERATOR_MAP[FilterContentFieldDataTypes.NUMBER],
    validationFn: (value: number | string) =>
      ((value as number) >= 0 && /^(-*)\d+$/.test(value as string)) || value === ''
  },
  [FilterContentFieldDataTypes.STRING]: {
    component: FilterWithOperator,
    options: DATA_TYPE_OPERATOR_MAP[FilterContentFieldDataTypes.NUMBER]
  },
  [FilterContentFieldDataTypes.DATE]: {
    component: DateRangePicker
  }
};
